import { takeEvery } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import Api from '../api';
import patternSaga from './patternSaga';
import utils from 'shared/utils';

const mobileAppVersionsUrl = `${utils.config.apiPlatformConfigUrl}/mobile-app-version`;

const getMobileAppVersionsConfig = {
  requestFunction: Api.User.getMobileAppVersions,
  requestUrl: mobileAppVersionsUrl
};

const putMobileAppVersionsConfig = {
  requestFunction: Api.User.putMobileAppVersions,
  requestUrl: mobileAppVersionsUrl,
  onSuccess: {
    trigAction: { type: ActionTypes.GET_MOBILE_APP_VERSIONS },
    notification: {
      staticNotification: true,
      data: {
        code: '0'
      }
    }
  },
  onFailure: {
    notification: true
  }
};

const syncMobileAppVersionsConfig = {
  requestFunction: Api.User.syncMobileAppVersions,
  requestUrl: `${mobileAppVersionsUrl}/sync`,
  onSuccess: {
    trigAction: { type: ActionTypes.GET_MOBILE_APP_VERSIONS },
    notification: {
      staticNotification: true,
      data: {
        code: '0'
      }
    }
  },
  onFailure: {
    notification: true
  }
};

export default function* watchMobileAppVersions() {
  yield takeEvery(ActionTypes.GET_MOBILE_APP_VERSIONS, patternSaga, getMobileAppVersionsConfig);
  yield takeEvery(ActionTypes.PUT_MOBILE_APP_VERSIONS, patternSaga, putMobileAppVersionsConfig);
  yield takeEvery(ActionTypes.SYNC_MOBILE_APP_VERSIONS, patternSaga, syncMobileAppVersionsConfig);
}
